import util from '@bmp-vue/core/api/util'

const controller = 'ConsultaCadastrosDbs'

const enc = (s) => encodeURIComponent(String(s ?? '').trim())

export default {
  ObterParceiro(filtro) {
    return util.Axios.Get(`${controller}/ObterParceiro/${enc(filtro)}`)
  },
  ObterConta(filtro) {
    return util.Axios.Get(`${controller}/ObterConta/${enc(filtro)}`)
  },
  ObterOperadorWhiteLabel(filtro) {
    return util.Axios.Get(`${controller}/ObterOperadorWhiteLabel/${enc(filtro)}`)
  },
  ObterOperadorBackOffice(filtro) {
    return util.Axios.Get(`${controller}/ObterOperadorBackOffice/${enc(filtro)}`)
  },
  ObterOperadorRetaguarda(filtro) {
    return util.Axios.Get(`${controller}/ObterOperadorRetaguarda/${enc(filtro)}`)
  },
}
